import * as styles from "./TabLayout.css";

import type { JSX, ReactNode } from "react";

export type TabColumnProps = {
  children: ReactNode;
};

export function TabColumn({ children }: TabColumnProps): JSX.Element {
  return <div className={styles.column}>{children}</div>;
}
